import { Card, CardContent, Grid, Typography } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import styles from "assets/jss/public-styles";
import AppLogo from 'components/AppLogo';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';
import { RoutePaths } from 'routes/RouteConfig';

////////////////////////////////////////////////////////////////////////////////////////

type Props = WithStyles<typeof styles> & RouteComponentProps<{}> & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////

const NotFound: React.FC<Props> = (props) => {
    const { classes, t } = props;

    return (
        <div className={classes.page}>
            <div className={classes.pageHeader}>
                <div className={classes.container}>
                    <Grid container justifyContent="center" direction="row" >
                        <Grid item xs={12} sm={8} md={6} lg={4}>
                            <Grid container>
                                <Grid item className={classes.logo}  >
                                    <AppLogo size="2x" />
                                </Grid>
                                <Grid item style={{ width: "100%" }}>
                                    <Card>
                                        <CardContent>

                                            <Typography variant="h4">{t("Views.Public.PageNotFound.HeaderTitle")}</Typography>

                                            <Typography variant="body1">
                                                <p>{t("Views.Public.PageNotFound.Msg1")}</p>
                                                <p>{t("Views.Public.PageNotFound.Msg2")}</p>
                                            </Typography>

                                            <MuiRegularButton
                                                color="primary"
                                                size="large"
                                                onClick={() => { props.history.replace(RoutePaths.TimelineStartup); }}
                                            >
                                                <span>{t("Common.Buttons.HomeText")}</span>
                                            </MuiRegularButton>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(withStyles(styles)(NotFound));